<script setup lang="ts">
import ToastElement from './ToastElement.vue';
import { IToast, useToastStore } from '@/stores/toast.store';
import { Reactive, reactive, ref, watch } from 'vue';

interface IDisplayedToast extends IToast {
  id: string;
}

const toastStore = useToastStore();

const toasts = toastStore.toasts;
const displayedToasts: Reactive<Array<IDisplayedToast>> = reactive([]);
const hiddenToasts: Reactive<Array<string>> = reactive([]);
const container$ = ref<HTMLElement | null>(null);

const updateToasts = () => {
  if (!container$.value) {
    return;
  }
  // TODO: Not working correctly, some toasts are still displayed
  while (hiddenToasts.length > 0) {
    const id = hiddenToasts.shift()!;
    const index = displayedToasts.findIndex((toast) => toast.id === id);
    displayedToasts.splice(index, 1);
  }
  // We should add a limit to the number of toasts displayed when first point is fixed
  while (toasts.length > 0) {
    const toast = toasts.shift()!;
    displayedToasts.push(toast);
  }
};

const toastHidden = (id: string) => {
  // Remove toast from displayed list
  hiddenToasts.push(id);
  // Re-update the toasts if there are more to display
  updateToasts();
};

watch(
  () => toasts.length,
  () => {
    updateToasts();
  },
  { immediate: true },
);
</script>

<template>
  <div ref="container$" class="toast-container position-fixed bottom-0 end-0 p-3">
    <ToastElement v-for="toast in displayedToasts" :key="toast.id" :toast="toast" @hidden="toastHidden" />
  </div>
</template>

<style scoped></style>
